import { useState, useEffect } from 'react';
import { User } from 'firebase/auth';
import { AuthService } from '../services/authService';

export const useAuth = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = AuthService.onAuthStateChanged((user) => {
      setUser(user);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const signInAnonymously = async () => {
    try {
      setLoading(true);
      const user = await AuthService.signInAnonymously();
      return user;
    } catch (error) {
      console.error('Failed to sign in anonymously:', error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const signOut = async () => {
    try {
      await AuthService.signOut();
    } catch (error) {
      console.error('Failed to sign out:', error);
      throw error;
    }
  };

  return {
    user,
    loading,
    signInAnonymously,
    signOut,
    isAuthenticated: !!user
  };
};
